var map = {
	"./logo_unihub.svg": [
		"7b80",
		"chunk-2d0e1839"
	],
	"./logo_unihubOld.svg": [
		"4f32",
		"chunk-2d0cc987"
	],
	"./logo_unihub_small.svg": [
		"52ec",
		"chunk-2d0c80f1"
	],
	"./logout.svg": [
		"309a",
		"chunk-2d0b8b5b"
	],
	"./menu-burger.svg": [
		"0e6d",
		"chunk-2d0af4d9"
	],
	"./user-profile.svg": [
		"1139",
		"chunk-2d0aa57c"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "7e7b";
module.exports = webpackAsyncContext;